import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const VerificationBannerStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleGrid: {
      background: theme.palette.primary.main,
      alignItems: "center",
      height: "71px",
      lineHeight: 1.21,
    },
    title: {
      fontSize: "19px",
      fontWeight: theme.typography.fontWeightBold,
      color: "#FFFFFF",
      textAlign: "center",
    },
    innerBox: {
      textAlign: "center",
      paddingTop: "24px",
      paddingBottom: "12px",
    },
    messageOne: {
      fontWeight: 600,
      padding: "0px 28px",
      color: theme.palette.primary.main,
      marginBottom: "12px",
    },
    messageTwo: {
      fontWeight: theme.typography.fontWeightRegular,
      padding: "0px 28px",
      color: "#5c6469",
      textAlign: "justify",
      lineHeight: 1.21,
      [theme.breakpoints.down("md")]: {
        marginTop: "10px",
      },
    },
    button: {
      flewGrow: 1,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      padding: "12px",
      borderRadius: "4px",
      background: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 600,
      color: "#FFFFFF",
      width: "-webkit-fill-available",
      "&:hover": {
        backgroundColor: "#d63838",
      },
    },
  }),
);
